import { Record } from 'immutable';
import { SortOrder } from './index.js';
export var IncludeMediaType;
(function (IncludeMediaType) {
    IncludeMediaType["PRIMARY"] = "primary";
    IncludeMediaType["ALL"] = "all";
})(IncludeMediaType || (IncludeMediaType = {}));
export var MediaAspectRatio;
(function (MediaAspectRatio) {
    MediaAspectRatio["NATURAL"] = "natural";
    MediaAspectRatio["SQUARE"] = "square";
})(MediaAspectRatio || (MediaAspectRatio = {}));
export var MediaAdornment;
(function (MediaAdornment) {
    MediaAdornment["ROUNDED"] = "rounded";
    MediaAdornment["SQUARE"] = "square";
})(MediaAdornment || (MediaAdornment = {}));
export var WatermarkLocationType;
(function (WatermarkLocationType) {
    WatermarkLocationType["TOP"] = "top";
    WatermarkLocationType["MIDDLE"] = "middle";
    WatermarkLocationType["BOTTOM"] = "bottom";
    WatermarkLocationType["TOP_LEFT"] = "topLeft";
    WatermarkLocationType["TOP_RIGHT"] = "topRight";
    WatermarkLocationType["BOTTOM_LEFT"] = "bottomLeft";
    WatermarkLocationType["BOTTOM_RIGHT"] = "bottomRight";
})(WatermarkLocationType || (WatermarkLocationType = {}));
export var WebPublishingAudience;
(function (WebPublishingAudience) {
    WebPublishingAudience["API_AND_HUB"] = "api_and_hub";
    WebPublishingAudience["API_ONLY"] = "api_only";
})(WebPublishingAudience || (WebPublishingAudience = {}));
export class CollectionWebPublishingRecord extends Record({
    on: undefined,
    euid_representative: undefined
}) {
}
//# sourceMappingURL=web-publishing.js.map